import { Component, OnInit } from '@angular/core';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

import { ReportSelectorService } from '../../../form-controls/services/report-selector.service';
import { SubHeader } from '../../../core/models/sub-header.model';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { ActionCellRendererComponent } from '../../../common/components/ag-grid/action-cell-renderer.component';
import { DomainDefinitionService } from '../../../builder/services/domain-definition.service';
import { DomainValue } from '../../../models/domain.model';
import { genId } from '../../../core/services/genId';
import { CommunicationType } from './communication-template-editor.component';
import { ReportTemplate } from '../../../models/comodel/mergefieldsmodel.model';
import { OnBaseDocumentType, OnBaseMappedKeyword } from '../../../common/models/onBaseIntegrationAndMapping.model';
import { OnBaseIntegrationAndMappingService } from '../../../common/services/onbase-integration-mapping.service';
import { DocumentManagementService } from '../../../common/services/document-management.service';
import { AuthService } from '../../../services/auth.service';
import { ReminderTypeOptions } from '../../models/reminders.model';
import { GridFormatterService } from '../../../common/services/grid-formatter.service';


@Component({
    selector: 'communication-templates',
    templateUrl: './communication-templates.component.html',
    styleUrls: ['./communication-templates.component.scss'],
    standalone: false
})
export class CommunicationTemplatesComponent implements OnInit {

    columnCategory = {
        headerName: 'Category',
        field: 'categoryCode',
        tooltipField: 'categoryCode',
        valueGetter: this.categoryFormatter(),
    } as ColDef;

    columnName = {
        headerName: 'Name',
        field: 'name',
        tooltipField: 'name',
        cellRenderer: ActionCellRendererComponent,
        cellRendererParams: {
            textField: 'name',
            action: this.edit(this)
        }
    } as ColDef;

    columnType = {
        headerName: 'Type',
        field: 'typeCode',
        tooltipField: 'typeCode',
        valueGetter: this.typeFormatter(),
    } as ColDef;

  columns = [this.columnName, this.columnType, this.columnCategory];
  chiefsOrdersOnBaseDocumentTypes: OnBaseDocumentType[];
  chiefsOrdersOnBaseKeywordTypes: OnBaseMappedKeyword[];
  data: ReportTemplate[];
	gridOptions: GridOptions;
	gridApi?: GridApi;
  chiefOrderCategories: DomainValue[];
  letterCategories: DomainValue[];
  reminderTypes: DomainValue[];
  selectedTemplate?: ReportTemplate;

  subHeader = new SubHeader({
    title: "Manage Communication Templates", buttons: []
  });

  types: DomainValue[];

  constructor(public domainService: DomainDefinitionService,
              public subHeaderService: SubHeaderService,
              public templateService: ReportSelectorService,
              public onBaseMappingService: OnBaseIntegrationAndMappingService,
              public onBaseDocumentService: DocumentManagementService,
	  public authService: AuthService,
	  private _formatter: GridFormatterService) {
    this._formatter.applyFilterKeyboardHintTooltips(this.columns);
  }

  ngOnInit() {

    this.subHeaderService.updateSubHeader(this.subHeader);

      this.reminderTypes = ReminderTypeOptions.All.map(a => { return { Code: a.id, Definition: a.text } as DomainValue });

    this.refreshData();

    this.gridOptions = <GridOptions>{
        columnDefs: this.columns,
        headerHeight: 50,
        defaultColDef: { filter: true, sortable: true } as ColDef,
        enableBrowserTooltips: false,
        tooltipTrigger: 'focus',
      onGridReady: (params) => {
		  this.gridApi = params.api;
		  this.gridApi.sizeColumnsToFit();
      },
      pagination: true,
      paginationAutoPageSize: true
    };
  }

  addTemplate(): void {
    this.selectedTemplate = {
      allowedSignerTypes: [],
      id: genId(),
      categoryCode: 'INS',
      reportContextValues: [],
      typeCode: CommunicationType.ChiefOrder,
    } as ReportTemplate;
  }

  categoryFormatter() {
    return (obj: any) => {
      switch (obj.data.typeCode.toLowerCase()) {
        case 'co': {
          const cat = this.chiefOrderCategories.find(x => x.Code.toLowerCase() === obj.data.categoryCode.toLowerCase());
          return cat ?  cat.Definition : 'Not found';
        }
        case 'letter': {
          const cat = this.letterCategories.find(x => x.Code.toLowerCase() === obj.data.categoryCode.toLowerCase());
          return cat ?  cat.Definition : 'Not found';
        }
        case 'reminder': {
              const cat = this.reminderTypes.find(x => x.Code.toLowerCase() === obj.data.categoryCode.toLowerCase());
          return cat ?  cat.Definition : 'Not found';
        }
        default: {
          return 'Not found';
        }
      }
    };
  }

  closeEditor(): void {
    this.selectedTemplate = undefined;
  }

  edit(component: CommunicationTemplatesComponent) {
    return (obj: any) => {
      component.selectedTemplate = obj.data;
    }
  }

  onTemplateSaved(template: ReportTemplate): void {
    const index = this.data.findIndex(x => x.id == template.id);
    if (index !== -1) {
      this.data[index] = template;
    } else {
      this.data.push(template);
    }
    this.closeEditor();
  }

  refreshData(): void {
    this.templateService.getAllTemplates().subscribe(templates => {
      this.data = templates;
    });
    this.domainService.get('CommunicationType').subscribe(data => {
      this.types = data.values;
    });
    this.domainService.get('LetterCategory').subscribe(data => {
      this.letterCategories = data.values;
    });
    this.domainService.get('ChiefsOrderCategory').subscribe(data => {
      this.chiefOrderCategories = data.values;
    });
    this.domainService.get('ChiefsOrderCategory').subscribe(data => {
      this.chiefOrderCategories = data.values;
    });
  }

  typeFormatter() {
    return (obj: any) => {
      const type = this.types.find(x => x.Code.toLowerCase() === obj.data.typeCode.toLowerCase());
      return type ?  type.Definition : 'Not found';
    };
  }

}

function as(arg0: (a: import("../../../common/models/flow.dto").Option) => void, as: any, DomainValue: any): DomainValue[] {
    throw new Error('Function not implemented.');
}
